import { useState } from "react";
import CriticalityBadge from "../CriticalityBadge";
import formatDate from "../../Utils/formatDate";
import SearchBar from "../UI/Searchbar";
import { Icon } from "../UI/Icon";
import usePatch from "../../Hooks/usePatch";
import API_ENDPOINTS from "../../Config/api";
import { toast } from 'react-toastify';
import Selector from "../UI/Selector"
import ClipLoader from 'react-spinners/ClipLoader'
import ModalWrapper from "../UI/ModalWrapper";

export default function CredenzialiEsposteTable1({
    data,
    setData,
    subData,
    setSubData,
}) {
    const [search, setSearch] = useState("");

    const filteredRows = (data?.email_stats ?? []).filter((item) =>
        (item.email ?? "").toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <div className="mb-4">
                <SearchBar search={search} setSearch={setSearch} />
            </div>

            <div className="flex flex-col h-[500px] overflow-hidden">
                {/* clip bordi arrotondati */}
                <div className="flex-1 min-h-0 border border-[#D1D5DB] rounded overflow-hidden">
                    {/* scroll PRINCIPALE della tabella */}
                    <div className="h-full overflow-y-auto [scrollbar-gutter:stable]">
                        <table className="w-full table-auto text-sm text-slate-200 border-collapse">
                            <colgroup>
                                <col className="w-[70%]" />
                                <col className="w-[10%]" />
                                <col className="w-[10%]" />
                                <col className="w-[10%]" />
                            </colgroup>

                            <thead className="text-black text-sm sticky top-0 z-10 bg-[#F3F4F7]">
                                <tr>
                                    <th className="px-3 py-5 text-left font-medium whitespace-nowrap">Asset</th>
                                    <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Num. violazioni</th>
                                    <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Rischio</th>
                                    <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Ultima violazione</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((item, i) => (
                                        <Row
                                            key={i}
                                            item={item}
                                            setSubData={setSubData}
                                            accordionItems={subData}
                                        />
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className="text-center py-6 text-slate-400">
                                            Nessun asset trovato
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

function Row({

    item,
    accordionItems = [],
    setSubData,

}) {

    const [open, setOpen] = useState(false);
    const rowId = `row-${(item?.email ?? "").replace(/[^a-z0-9]/gi, "_")}`;

    const list = Array.isArray(accordionItems?.results)
        ? accordionItems.results
        : Array.isArray(accordionItems)
            ? accordionItems
            : [];

    const sameEmailItems = list.filter((el) => el?.email === item?.email);

    return (
        <>
            {/* ROW PRINCIPALE */}
            <tr
                className="text-black bg-[#E3E3E3] cursor-pointer"
                onClick={() => setOpen((v) => !v)}
            >
                <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                        <Icon
                            className={`w-3 h-3 text-gray-700 transition-transform duration-500 ${open ? "rotate-180" : ""
                                }`}
                            name={"arrow"}
                        />
                        <p className="font-semibold leading-tight">{item?.email ?? "--"}</p>
                    </div>
                </td>

                <td className="px-3 py-3 text-center tabular-nums">
                    {item?.breaches ?? "--"}
                </td>

                <td className="px-3 py-3 flex justify-center tabular-nums">
                    <CriticalityBadge livello={item?.exposure_level} />
                </td>

                <td className="px-3 py-3 text-center tabular-nums">
                    {item?.last_breach_date ? formatDate(item.last_breach_date) : "-"}
                </td>
            </tr>

            {/* ROW DETTAGLI (ACCORDION) */}
            <tr id={`${rowId}-details`} className="bg-[#F8F9FB] border-white border-b-4">
                <td colSpan={5} className="px-3 py-0 align-top overflow-hidden">
                    <div className={`transition-[max-height] duration-500 ease-in-out ${open ? "max-h-[420px] overflow-y-auto" : "max-h-0 overflow-hidden"}`}>
                        <div className={`transition-opacity duration-300 ${open ? "opacity-100 py-4" : "opacity-0 py-0"}`}>
                            {sameEmailItems.length > 0 ? (
                                <ul className="space-y-2 pr-2">
                                    {sameEmailItems.map((item, index) => (
                                        <SubRow
                                            index={index}
                                            item={item}
                                            setSubData={setSubData}
                                            subData={accordionItems}
                                        />
                                    ))}
                                </ul>
                            ) : (
                                <div className="text-sm text-gray-500">
                                    Nessuna credenziale esposta.
                                </div>
                            )}

                        </div>
                    </div>
                </td>
            </tr>
        </>
    );
}


function SubRow({
    index,
    item,
    setSubData,
    subData
}) {



    const { patchData, loading } = usePatch()

    const [statusSelected, setStatusSelected] = useState(item.status)
    const [showNoteModal, setShowNoteModal] = useState(false);

    const [nota, setNota] = useState(item.status_note);
    const [prevNota, setPrevNota] = useState();

    const STATUS_OPTIONS = [
        { value: "open", label: "Aperto" },
        { value: "managed", label: "Gestito" },
        { value: "resolved", label: "Risolto" },
        { value: "false_positive", label: "Falso positivo" },
    ];

    async function handleSaveStatus(valueSelector) {
        try {
            const res = await patchData(API_ENDPOINTS.changeStatusCredential(item.id),
                { status: valueSelector, }
            );
            setSubData(prev => {
                if (!prev?.results) return prev; // safety nel caso in cui prev sia undefined/null
                return {
                    ...prev,
                    results: prev.results.map(f =>
                        f.id === item.id ? { ...f, status: valueSelector } : f
                    ),
                };
            });
            setStatusSelected(valueSelector)
            toast.success("Stato aggiornato");
        } catch (err) {
            toast.error(`Errore aggiornamento stato: ${err?.message ?? "errore sconosciuto"}`);
        }
    }

    async function handleSaveStatusNote(prevNota) {


        try {
            const res = await patchData(API_ENDPOINTS.changeStatusCredential(item.id),
                { status_note: prevNota }
            );
            setSubData(prev => {
                if (!prev?.results) return prev; // safety nel caso in cui prev sia undefined/null
                return {
                    ...prev,
                    results: prev.results.map(f =>
                        f.id === item.id ? { status_note: prevNota } : f
                    ),
                };
            });
            setNota(prevNota)
            setShowNoteModal(false)
            toast.success("Stato aggiornato");
        } catch (err) {
            toast.error(`Errore aggiornamento stato: ${err?.message ?? "errore sconosciuto"}`);
        }
    }


    return (
        <li
            key={item.id}
            className="rounded-md bg-white border border-gray-200 py-3 px-6 text-sm text-gray-800"
        >
            {/* Row: left chips + right button */}
            <div className="flex items-center justify-between">
                <div className="flex flex-col">

                    <div className="flex gap-2 items-center justify-start">
                        <span className="font-medium">
                            {item.title ?? item.source ?? `#${index + 1}`}
                        </span>
                        <span className="px-2 py-0.5 text-xs rounded bg-gray-100 border border-gray-200">
                            {item.breach_date ? formatDate(item.breach_date) : "-"}
                        </span>
                        {item.exposure_level && (
                            <span className="px-2 py-0.5 text-xs">
                                {/* {String(item.exposure_level).toUpperCase()} */}

                                <CriticalityBadge livello={item.exposure_level} />
                            </span>
                        )}
                    </div>
                    {item.description && (
                        <p className="text-gray-700 mt-2">{item.description}</p>
                    )}
                </div>
                <div className="flex items-center gap-5">
                    <div className="flex flex-col gap-1 w-36">
                        <p className="font-semibold">Stato</p>
                        {loading && !showNoteModal ?
                            <div className="flex justify-center">
                                <ClipLoader size={15} />
                            </div>
                            :
                            <Selector
                                options={STATUS_OPTIONS}
                                value={statusSelected}
                                onChange={handleSaveStatus}
                                width="w-36"
                                rightIcon={false}
                            />
                        }
                    </div>
                    <div className="flex gap-2">
                        <p>Nota:</p>
                        <button className="hover:scale-105 duration-300" onClick={() => setShowNoteModal(true)}>
                            <Icon name={"edit"} />
                        </button>
                    </div>

                </div>
            </div>



            <ModalWrapper position="center" isOpen={showNoteModal} onClose={() => setShowNoteModal(false)}>
                <div className="bg-[#F3F4F7] rounded-lg shadow-md p-6 w-[600px] mx-auto">
                    <div className="flex flex-col gap-2 mb-4 mt-4">
                        <p className="text-sm text-left font-semibold text-black">Nota</p>
                        <textarea
                            name=""
                            id=""
                            className="w-full min-h-[120px] rounded-md border border-gray-300 px-3 py-2 bg-white text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 resize-y"
                            placeholder="Aggiungi una nota..."
                            value={nota}
                            onChange={(e) => setPrevNota(e.target.value)}
                        />
                    </div>

                    <div className="mt-2 flex items-center justify-end gap-2">
                        <button
                            type="button"
                            className="px-3 py-2 rounded border border-gray-300 bg-white text-black hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
                            onClick={() => setShowNoteModal(false)}
                        >
                            Annulla
                        </button>
                        <button
                            type="button"
                            className="px-3 py-2 w-20 rounded bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            onClick={() => handleSaveStatusNote(prevNota)}
                        >
                            {
                                loading ?
                                    <ClipLoader size={15} /> : 'Salva'
                            }
                        </button>
                    </div>
                </div>
            </ModalWrapper>
        </li>
    )
}